export const SIDEBARNAV_POSITION = "SIDEBARNAV_POSITION";
export const CHANGE_THEME = "CHANGE_THEME";

export const SHOW_LOADING_COMPONENT = "SHOW_LOADING_COMPONENT";

export const SHOW_ERROR_TEXT_INTERCEPTOR = "SHOW_ERROR_TEXT_INTERCEPTOR";

//Auth
export const SIGNIN_REQUEST = "SIGNIN_REQUEST";
export const SIGNIN_SUCCESS = "SIGNIN_SUCCESS";
export const SIGNIN_FAILURE = "SIGNIN_FAILURE";

export const SIGNOUT_REQUEST = "SIGNOUT_REQUEST";
export const SIGNOUT_SUCCESS = "SIGNOUT_SUCCESS";
export const SIGNOUT_FAILURE = "SIGNOUT_FAILURE";

export const VERIFY_REQUEST = "VERIFY_REQUEST";
export const VERIFY_SUCCESS = "VERIFY_SUCCESS";

export const REAUTHENTICATE_CREDENTIAL_REQUEST = "REAUTHENTICATE_CREDENTIAL_REQUEST";
export const REAUTHENTICATE_CREDENTIAL_SUCCESS = "REAUTHENTICATE_CREDENTIAL_SUCCESS";
export const REAUTHENTICATE_CREDENTIAL_FAILURE = "REAUTHENTICATE_CREDENTIAL_FAILURE";

export const UPDATE_PASSWORD_REQUEST = "UPDATE_PASSWORD_REQUEST";
export const UPDATE_PASSWORD_SUCCESS = "UPDATE_PASSWORD_SUCCESS";
export const UPDATE_PASSWORD_FAILURE = "UPDATE_PASSWORD_FAILURE";

export const SIGNUP_REQUEST = "SIGNUP_REQUEST";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_FAILURE = "SIGNUP_FAILURE";

export const VERIFY_EMAIL_REQUEST = "VERIFY_EMAIL_REQUEST";
export const VERIFY_EMAIL_SUCCESS = "VERIFY_EMAIL_SUCCESS";
export const VERIFY_EMAIL_FAILURE = "VERIFY_EMAIL_FAILURE";

export const VERIFY_PASSWORD_RESETCODE_REQUEST = "VERIFY_PASSWORD_RESETCODE_REQUEST";
export const VERIFY_PASSWORD_RESETCODE_SUCCESS = "VERIFY_PASSWORD_RESETCODE_SUCCESS";
export const VERIFY_PASSWORD_RESETCODE_FAILURE = "VERIFY_PASSWORD_RESETCODE_FAILURE";

export const CONFIRM_PASSWORD_RESET_REQUEST = "CONFIRM_PASSWORD_RESET_REQUEST";
export const CONFIRM_PASSWORD_RESET_SUCCESS = "CONFIRM_PASSWORD_RESET_SUCCESS";
export const CONFIRM_PASSWORD_RESET_FAILURE = "CONFIRM_PASSWORD_RESET_FAILURE";

export const SEND_VERIFICATION_EMAIL_REQUEST = "SEND_VERIFICATION_EMAIL_REQUEST";
export const SEND_VERIFICATION_EMAIL_SUCCESS = "SEND_VERIFICATION_EMAIL_SUCCESS";
export const SEND_VERIFICATION_EMAIL_FAILURE = "SEND_VERIFICATION_EMAIL_FAILURE";

export const UPDATE_TOKEN = "UPDATE_TOKEN";

export const UPDATE_ACCOUNT_ASSIGNED = "UPDATE_ACCOUNT_ASSIGNED";
